import { jwtDecode } from "jwt-decode";

/** True when the access token is missing, unreadable or past its expiry time. */
export const isTokenExpired = (token: string | null | undefined): boolean => {
  if (!token) return true;
  try {
    const { exp } = jwtDecode<{ exp?: number }>(token);
    return !!exp && exp * 1000 <= Date.now();
  } catch {
    return true;
  }
};

/** Clears the local session (same keys as logout in AppHeader). */
export const clearSession = () => {
  useCookie("access_token").value = null;
  if (import.meta.client) {
    sessionStorage.removeItem("user");
    sessionStorage.removeItem("selectedCustomer");
  }
};
